import { chartEmptyValueConstants } from '@/utils/reports/chartEmptyValueConstants';
import { REQUISITION_TYPE_CONFIG } from '@/constants/requisition-constants';

const emptyKeyMap = {
  requisitions_by_department: 'department',
  requisitions_by_requisition_type: 'requisition_type',
};

/**
 * Transforms interview data for feedback and duration charts
 * @param response API response data
 * @param feedbackKeys keys for feedback metrics
 * @returns Object containing data for both charts
 */
export const requisitionsVisualsTransformer = ({ response, metadata }) => {
  const { table = [], lookups: { g1 = {} } = {} } = response || {};

  const { tileKey } = metadata || {};
  const emptyKey = emptyKeyMap[tileKey];

  const formattedData = table?.map((curr) => {
    const group = curr[2]; // Index into g1 array
    const value = curr[4]; // The metric value

    const lookupValue = g1[group]; // Get the actual lookup value from array

    // If it's an object with name property (department/location objects)
    if (typeof lookupValue === 'object' && lookupValue !== null) {
      return {
        value,
        name: lookupValue.name,
        id: lookupValue.id,
      };
    }

    // If it's a string (requisition type like "backfill", "internal", "new_hire")
    if (typeof lookupValue === 'string') {
      const displayLabel =
        REQUISITION_TYPE_CONFIG[lookupValue]?.label || lookupValue;
      return {
        value,
        name: displayLabel,
        key: lookupValue,
      };
    }

    return { value, key: lookupValue };
  }, []);

  // made changes to the series and categories to match the format of other charts
  const series = [];
  const categories = [];
  formattedData?.forEach((x) => {
    const originalName =
      x?.name || chartEmptyValueConstants[emptyKey] || 'Not found';

    // Map specific names to their new values
    const displayName = originalName;

    series.push({
      name: displayName,
      y: x?.value,
      g1: x?.id || x?.key || null,
    });
    categories.push(displayName);
  });

  return {
    series,
    categories,
  };
};
